var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"data":_vm.data,"onManager":_vm.onManager,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"nameRules":[{ required: true, message: '请输入名称' }]}})}
var staticRenderFns = []

export { render, staticRenderFns }